// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
import Authorize, { Unauthorize } from './Authorize';

import { IRoute } from '../';

const authorizationRoutes: IRoute[] = [
    {
        crumbText: 'authorizing',
        component: Authorize,
        exact: true,
        path: '/authorize',
        public: true,
    },
    {
        crumbText: 'unauthorized',
        component: Unauthorize,
        exact: true,
        path: '/unauthorized',
        public: true,
    },
];

export default authorizationRoutes;
